import React, { useEffect } from "react";
import  { useNavigate } from "react-router-dom";   
import '../css/common.css'; // Assuming you have a CSS file for styling
import { useMsal } from "@azure/msal-react";
import { getManagerInfo } from "../utils/api";

export const HomeScreen = () => {
    const navigation = useNavigate();
    const { instance } = useMsal();
    useEffect(() => {

      const getUser = async () => {
        const user = await getManagerInfo(instance);
      }
      getUser();

    },[]);

    return (
    <div className="container">
        <h1>Magni App</h1>
        <p>Click on any of the links below to access the different pages:</p>
        
        <div className="magni-nav-links">
          <button className="magni-nav-link" style={{borderColor: 'transparent'}} onClick={() => navigation('/calendar')}>Calendar</button>
          <button className="magni-nav-link" style={{borderColor: 'transparent'}} onClick={() => navigation('/signout')}>Sign In/Out</button>
          <button className="magni-nav-link" style={{borderColor: 'transparent'}} onClick={() => navigation('/manager-view')}>Managers</button>
        </div>
      </div>
    );
}